import { render, staticRenderFns } from "./error.vue?vue&type=template&id=1a22e089&scoped=true&lang=pug"
import script from "./error.vue?vue&type=script&lang=coffee"
export * from "./error.vue?vue&type=script&lang=coffee"
import style0 from "./error.vue?vue&type=style&index=0&id=1a22e089&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a22e089",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BlocksList: require('/opt/build/repo/site/components/globals/blocks/list.vue').default})
